import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { addWaterJugs, editWaterJugs, getWaterJugs } from '../../Services/WaterJug/action';
import { deleteRecord } from '../../Services/Delete/action';

const AddUpdateWaterJug = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;

    const [Fields, setFields] = useState({
        today_date: data?.today_date || moment().format('YYYY-MM-DD'),
        no_of_jug: data?.no_of_jug || 1,
    });

    const handleSave = async () => {
        try {
            if (!Fields.today_date || !Fields.no_of_jug) {
                toast.error("Please fill all required fields");
                return;
            }

            const payload = {
                today_date: Fields.today_date,
                no_of_jug: Fields.no_of_jug,
                user_id: props?.user?.id,
            };

            if (!data) {
                const existingRecord = props.waterjug?.find(
                    (jug) =>
                        moment(jug.today_date).format('YYYY-MM-DD') === Fields.today_date &&
                        jug.user_id === props?.user?.id
                );

                if (existingRecord) {
                    toast.warning("Water jug for today is already added!");
                    return;
                }

                await props.addWaterJug(payload);
            } else {
                await props.editWaterJugs(data?.id, payload);
            }

            await props.getWaterJugs();
            navigate(-1);
        } catch (error) {
            console.error("Error saving water jug:", error);
            toast.error("Something went wrong");
        }
    };

    return (
        <div className='ticket-container mb-5'>
            <div className="page-title">
                <h4>{location.pathname === "/waterjug/add" ? "Add" : "Update"} Water Jug</h4>
                <div className='edit-btn'>
                    <button
                        type="button"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="custom-btn"
                        onClick={handleSave}
                    >
                        Save
                    </button>
                </div>
            </div>

            <div className='row parent-filter m-0 pt-4 pb-5 h-auto mb-4'>
                <div className="col-lg-6 mb-4">
                    <div className="input-group">
                        <label className="label w-100">
                            Select Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <DatePicker
                            selected={Fields.today_date ? new Date(Fields.today_date) : null}
                            onChange={(date) => {
                                const formatted = moment(date).format('YYYY-MM-DD');
                                setFields({ ...Fields, today_date: formatted });
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select date"
                            className="input-css"
                        />
                    </div>
                </div>

                <div className="col-lg-6 mb-4">
                    <label className='form-label'>
                        Number of Jugs <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                        type="number"
                        className="input-css"
                        placeholder="Enter number of jugs"
                        min="1"
                        value={Fields.no_of_jug}
                        onChange={(e) => setFields({ ...Fields, no_of_jug: e.target.value })}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.waterJugReducer.loading,
        waterjug: state.waterJugReducer.waterjug,
        user: state.authenticationReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addWaterJug: (data) => dispatch(addWaterJugs(data)),
        editWaterJugs: (id, data) => dispatch(editWaterJugs(id, data)),
        getWaterJugs: () => dispatch(getWaterJugs()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateWaterJug);
